module.exports = ["/images/gallery/relax1.jpg","/images/gallery/relax2.jpg","/images/gallery/relax3.jpg","/images/gallery/work1.jpeg","/images/gallery/work2.jpeg","/images/gallery/work3.jpeg","/images/gallery/relax4.jpg","/images/gallery/relax5.jpg","/images/gallery/relax6.jpg","/images/gallery/work4.jpeg","/images/gallery/work5.jpeg","/images/gallery/work6.jpg","/images/gallery/relax8.jpg","/images/gallery/relax9.jpg","/images/gallery/relax7.jpg","/images/gallery/work7.jpg","/images/gallery/work8.jpg","/images/gallery/work9.jpg"]


//////////////////
// WEBPACK FOOTER
// ./src/data/gallery.json
// module id = 606
// module chunks = 176098834507362